import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
function DestinationTab({ destinations, id, hastag}) {
  const [specialties,setSpecialties]=useState([]);
  const history = useHistory()
  const itemCount = specialties.length;
  const itemCountLeft = Math.ceil(itemCount) / 2;
  useEffect(() => {
    fetch("https://610ec1597f793c00174195b7.mockapi.io/api/specialties/")
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const filter = data.filter(
          (spec) => spec.destination_id === destinations.id
        );
        setSpecialties(filter);
      });
  }, [specialties]);
  const { TabPane } = Tabs;
  return (
    <div className="container">
      <div className="tabList tabStyles">
        <Tabs activeKey={hastag}
               onChange={(key) => {
                 history.push(`/destination/${id}/${key}`);
              }}>
          <TabPane tab="Chung" key="all">
            <div className="row" id="all">
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties && specialties
                  .slice(0, itemCountLeft)
                  .map((item, index) => {
                    return (
                      <div className="contentTab">
                        <div key={index} className="contentTabBox">
                          <div className="imgBox">
                            <img
                              className="img-fluid"
                              src={item.image}
                              alt=""
                            />
                          </div>
                          <div className="contentBox">
                            <p>{item.description}</p>
                            <p className="map">
                              <FontAwesomeIcon icon="map-marked-alt" />
                              {item.address}
                            </p>
                          </div>
                        </div>
                        <div className="titleName">
                          <h5>{item.name}</h5>
                          <p className="hastag">#{item.type_name}</p>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                  .slice(itemCountLeft,itemCount)
                  .map((item, index) => {
                    return (
                      <div>
                        <div key={index} className="contentTabBox">
                          <div className="imgBox">
                            <img
                              className="img-fluid"
                              src={item.image}
                              alt=""
                            />
                          </div>
                          <div className="contentBox">
                            <p>{item.description}</p>
                            <p>
                              <FontAwesomeIcon icon="map-marked-alt" />
                              {item.address}
                            </p>
                          </div>
                        </div>
                        <div className="titleName">
                          <h5>{item.name}</h5>
                          <p>#{item.type_name}</p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </TabPane>
          <TabPane  tab="Du lịch" key="travel">
            <div className="row">
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "travel")
                    .splice(0, itemCountLeft)
                    .map((item, index) => {
                      return (
                        <div className="contentTab">
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p className="map">
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p className="hastag">#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "travel")
                    .slice(itemCountLeft,itemCount)
                    .map((item, index) => {
                      return (
                        <div>
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p>
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p>#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </TabPane>
          <TabPane  tab="Ẩm thực" key="cuisine">
            <div className="row">
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "cuisine")
                    .splice(0, itemCountLeft)
                    .map((item, index) => {
                      return (
                        <div className="contentTab">
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p className="map">
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p className="hastag">#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "cuisine")
                    .slice(itemCountLeft,itemCount)
                    .map((item, index) => {
                      return (
                        <div>
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p>
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p>#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </TabPane>
          <TabPane  tab="Mua sắm" key="shopping">
            <div className="row">
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "shopping")
                    .splice(0, itemCountLeft)
                    .map((item, index) => {
                      return (
                        <div className="contentTab">
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p className="map">
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p className="hastag">#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "shopping")
                    .slice(itemCountLeft,itemCount)
                    .map((item, index) => {
                      return (
                        <div>
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p>
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p>#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </TabPane>
          <TabPane tab="sự kiện"key="eventas">
            <div className="row">
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "eventas")
                    .splice(0, itemCountLeft)
                    .map((item, index) => {
                      return (
                        <div className="contentTab">
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p className="map">
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p className="hastag">#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
              <div className="col-lg-6 col-12 col-md-6 formCol">
                {specialties &&
                  specialties
                    .filter((hastag) => hastag.type_name === "eventas")
                    .slice(itemCountLeft,itemCount)
                    .map((item, index) => {
                      return (
                        <div>
                          <div key={index} className="contentTabBox">
                            <div className="imgBox">
                              <img
                                className="img-fluid"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="contentBox">
                              <p>{item.description}</p>
                              <p>
                                <FontAwesomeIcon icon="map-marked-alt" />
                                {item.address}
                              </p>
                            </div>
                          </div>
                          <div className="titleName">
                            <h5>{item.name}</h5>
                            <p>#{item.type_name}</p>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}
export default DestinationTab;
